export const IntegrationType = {
    Meta: '1',
    Gupshup: '2'
};
